export class Result {
    id: number;
    msgcd: string;
    message: string;
    data: any;
}
